import { v4 as uuidv4 } from 'uuid';
import FJUtil from '../util/FJUtil';
import FJConfig from '../config/FJConfig';

const MAX_CONCURRENT = 20;

const _worker = new Worker(FJConfig.COMMON_WORKER_PATH);
const _transferFontArrayBufferSet = new Set();

let _concurrentCreateFontBase64 = 0;

async function createFontBase64(fontArrayBuffer, glyphs) {
    try {
        // 等待上一次的字体转换完成，避免创建过多的 ArrayBuffer
        await FJUtil.polling(
            () => !_transferFontArrayBufferSet.has(fontArrayBuffer) && _concurrentCreateFontBase64 < MAX_CONCURRENT,
            50,
            Infinity,
        );

        _concurrentCreateFontBase64++;
        const id = uuidv4();
        _transferFontArrayBufferSet.add(fontArrayBuffer);
        _worker.postMessage({ id, type: 'createFontBase64', options: { fontArrayBuffer, glyphs } }, [fontArrayBuffer]);
        const { isAllGlyphs, base64 } = await new Promise((resolve, reject) => {
            const fn = msg => {
                const { id: msgId, type, data, message } = msg.data;
                if (id === msgId) {
                    _worker.removeEventListener('message', fn);
                    switch (type) {
                        case 'createFontBase64':
                            resolve(data);
                            break;
                        default:
                            reject(new Error(`createFontBase64 fail - ${message}`));
                    }
                }
            };
            _worker.addEventListener('message', fn);
        });
        _transferFontArrayBufferSet.delete(fontArrayBuffer);
        return { isAllGlyphs, base64 };
        // eslint-disable-next-line no-useless-catch
    } catch (e) {
        throw e;
    } finally {
        _concurrentCreateFontBase64--;
    }
}

export default {
    createFontBase64,
};
